(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["which-biosafe"] && !Shopify.designMode) return;
  try {
    
  $("#startBtn").click(function(){
    $("#which-biosafe").slideUp(500);
    $("#question1").slideDown(500)
  });

  var q1Answer = 0;
  

  $("#q1a1btn").click(function(){
    q1Answer = 1;
    $("#question1").slideUp(500);
    $("#question2").slideDown(500);
    $("#q2a3btn").css("display","none");
    $("#q2a4btn").css("display","none");
  });
  $("#q1a2btn").click(function(){
    q1Answer = 2;
    $("#question1").slideUp(500);
    $("#question2").slideDown(500);
    $("#q2a2btn").css("display","none");
  });
  $("#q1a3btn").click(function(){
    q1Answer = 3;
    $("#question1").slideUp(500);
    $("#question3").slideDown(500);
    $("#q3a17btn").css("display","block");
    $("#q3a18btn").css("display","block");
    $("#q3a19btn").css("display","block");
  });

  $("#q2a1btn").click(function(){
    $("#question2").slideUp(500);
    $("#question3").slideDown(500);
    if(q1Answer == 2){
      $("#q3a7btn").css("display","block");
      $("#q3a8btn").css("display","block");
      $("#q3a9btn").css("display","block");
      $("#q3a9abtn").css("display","block");
    }else{
      $("#q3a1btn").css("display","block");
      $("#q3a2btn").css("display","block");
      $("#q3a3btn").css("display","block");
      $("#q3a3abtn").css("display","block");
    }
  }); 
  $("#q2a2btn").click(function(){
    $("#question2").slideUp(500);
    $("#question3").slideDown(500);
    $("#q3a4btn").css("display","block");
    $("#q3a5btn").css("display","block");
    $("#q3a6btn").css("display","block");
  });
  $("#q2a3btn").click(function(){
    $("#question2").slideUp(500);
    $("#question3").slideDown(500);
    $("#q3a10btn").css("display","block");
    $("#q3a11btn").css("display","block");
    $("#q3a12btn").css("display","block");
    $("#q3a13btn").css("display","block");
  });
  $("#q2a4btn").click(function(){
    $("#question2").slideUp(500);
    $("#question3").slideDown(500);
    $("#q3a14btn").css("display","block");
    $("#q3a15btn").css("display","block");
    $("#q3a16btn").css("display","block");
  });

  $("#q3a1btn, #q3a7btn, #q3a10btn").click(function(){
    $("#question3").slideUp(500);
    $("#testFinal").slideDown(500);
    $("#ac250span").css("display","block");
    $("#normaltext").css("display","block");
    $("#ac1500text").css("display","none");
  });
  $("#q3a2btn, #q3a4btn, #q3a8btn, #q3a11btn, #q3a14btn, #q3a17btn").click(function(){
    $("#question3").slideUp(500);
    $("#testFinal").slideDown(500);
    $("#ac500span").css("display","block");
    $("#normaltext").css("display","block");
    $("#ac1500text").css("display","none");
  });
  $("#q3a3btn, #q3a5btn, #q3a9btn, #q3a12btn, #q3a15btn, #q3a18btn").click(function(){
    $("#question3").slideUp(500);
    $("#testFinal").slideDown(500);
    $("#ac750span").css("display","block");
    $("#normaltext").css("display","block");
    $("#ac1500text").css("display","none");
  });
  $("#q3a13btn, #q3a16btn, #q3a19btn, #q3a3abtn, #q3a6btn, #q3a9abtn").click(function(){
    $("#question3").slideUp(500);
    $("#testFinal").slideDown(500);
    $("#ac1500span").css("display","block");
    $("#normaltext").css("display","none");
    $("#ac1500text").css("display","block");
  });

  $("#restartTest").click(function(){
    $("#testFinal").slideUp(500);
    $("#question1").slideDown(500);
    $("#ac1500span").css("display","none");
    $("#ac750span").css("display","none");
    $("#ac500span").css("display","none");
    $("#ac250span").css("display","none");
    $("#q3a19btn").css("display","none");
    $("#q3a18btn").css("display","none");
    $("#q3a17btn").css("display","none");
    $("#q3a16btn").css("display","none");
    $("#q3a15btn").css("display","none");
    $("#q3a14btn").css("display","none");
    $("#q3a13btn").css("display","none");
    $("#q3a12btn").css("display","none");
    $("#q3a11btn").css("display","none");
    $("#q3a10btn").css("display","none");
    $("#q3a9btn").css("display","none");
    $("#q3a8btn").css("display","none");
    $("#q3a7btn").css("display","none");
    $("#q3a6btn").css("display","none");
    $("#q3a5btn").css("display","none");
    $("#q3a4btn").css("display","none");
    $("#q3a3btn").css("display","none");
    $("#q3a2btn").css("display","none");
    $("#q3a1btn").css("display","none");
    $("#q2a1btn").css("display","block");
    $("#q2a2btn").css("display","block");
    $("#q2a3btn").css("display","block");
    $("#q2a4btn").css("display","block");
    $("#q3a3abtn").css("display","block");
    $("#q3a9abtn").css("display","block");
    
  });

  
  
    

  } catch(e) { console.error(e); }
})();
})();
